import React from 'react';
import { connect } from 'react-redux';
import UserInfo from '../../../headers/UserInfo/UserInfo';
import HeaderNavigation from '../../../headers/HeaderNavigation/HeaderNavigation';
import PageHeader from '../../../headers/PageHeader/PageHeader';
import servers from '../../../../const/servers';
import canChangeEnvironment from '../../../../services/mini/canChangeEnvironment';
import ComboBox from '../../../components/ComboBox/ComboBox';
import EnvironmentItem from '../../../components/EnvironmentItem/EnvironmentItem';
import ProjectTagSelector from '../ProjectTagSelector/ProjectTagSelector';
import CreateOrSwitchToLastTagBtn from '../CreateOrSwitchToLastTagBtn/CreateOrSwitchToLastTagBtn';

class ProjectHeaderMobile extends React.PureComponent {
  changeEnvironment = (environmentObj) => {
    const { project, environment, tier, changeEnvironment } = this.props;
    const newEnvironment = environmentObj.key;

    if (newEnvironment === environment) {
      return;
    }

    if (canChangeEnvironment(tier, newEnvironment)) {
      changeEnvironment({ project, environment: newEnvironment });
    }
  };

  render() {
    const { environment, project, scriptName } = this.props;
    return (
      <React.Fragment>
        <div className="project-header-mobile">
          <PageHeader
            leftPart={
              <React.Fragment>
                <HeaderNavigation projectName={this.props.projectName} />
              </React.Fragment>
            }
            rightPart={
              <React.Fragment>
                <UserInfo hideBalanceBlock={true} />
              </React.Fragment>
            }
          />
          <div className="project-header-mobile__version-and-environment-row">
            <ComboBox
              values={servers}
              valueKey="key"
              valueName="name"
              width="142px"
              classes={environment}
              environmentItem={true}
              selectedValueId={environment}
              onValueSelect={this.changeEnvironment}
              tooltipMsg="Switch between Development, Testing,<br/>and Production environments"
              tooltipId="environmentCbTooltip"
              renderItem={(serverItem) => {
                return (
                  <EnvironmentItem serverItem={serverItem} project={project} />
                );
              }}
            />
            <div className="project-header-mobile__version-col">
              <ProjectTagSelector
                environment={environment}
                className="project-mobile-version-switcher"
              />
              <CreateOrSwitchToLastTagBtn
                project={project}
                scriptName={scriptName}
                environment={environment}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps({ projectsInfo, user }, ownProps) {
  const scriptName = ownProps.scriptName;
  return {
    project: projectsInfo.currentProject,
    tier: user.tier,
    scriptName,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectHeaderMobile);
